"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OffersColumn = exports.FilterColumn = exports.OffersMain = exports.StyledPagination = void 0;
exports.Offers = Offers;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const Api = __importStar(require("@src/api"));
const config_1 = __importDefault(require("@src/config"));
const classnames_1 = __importDefault(require("classnames"));
const react_intl_1 = require("react-intl");
const styled_components_1 = __importDefault(require("styled-components"));
const elements_1 = require("@src/components/elements");
const Pagination_1 = __importDefault(require("@src/components/elements/Pagination"));
const Offer_1 = require("@src/components/pages/offers/modules/Offer");
const loading_wrapper_1 = __importDefault(require("@src/components/modules/global/loading-wrapper"));
const FilterTags_1 = require("@src/components/pages/offers/modules/FilterTags");
const Filters_1 = require("@src/components/pages/offers/modules/filters/Filters");
const MissingContentView_1 = __importDefault(require("@src/components/modules/MissingContentView/MissingContentView"));
const styled_breakpoints_1 = require("styled-breakpoints");
const react_styled_1 = require("styled-breakpoints/react-styled");
const account_context_1 = require("@src/context/account-context");
const OfferSearchFilterWrapper_1 = require("@src/components/pages/offers/modules/OfferSearchFilterWrapper");
const mergePromotedOffersWithOffers_1 = require("@src/helpers/mergePromotedOffersWithOffers");
const offer_filter_context_1 = require("./offer-filter-context");
const OfferNotificationSubscriptionModal_1 = require("./modules/OfferNotificationSubscriptionModal");
const OfferNotificationSubscriptionPanel_1 = require("./modules/OfferNotificationSubscriptionPanel");
exports.StyledPagination = (0, styled_components_1.default)(Pagination_1.default) `
	display: flex;
	justify-content: center;
	padding: 2em 0;
`;
function OffersList({ offers }) {
    const areOffersNotEmpty = offers && offers.length;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: areOffersNotEmpty &&
            (offers === null || offers === void 0 ? void 0 : offers.map((offer) => ((0, jsx_runtime_1.jsx)("li", { className: (0, classnames_1.default)({
                    panel: true,
                    'panel--offer': true,
                    'panel--offer-important': offer.importantEmployer,
                }), children: (0, jsx_runtime_1.jsx)(Offer_1.Offer, { values: offer }) }, `offer-${offer.id}${offer.isPromoted ? '-promoted' : null}`)))) }));
}
function Offers() {
    const account = (0, account_context_1.useAccount)();
    const intl = (0, react_intl_1.useIntl)();
    const { offers, promotedOffers, arePromotedOffersLoading, areOffersLoading, areFiltersLoading, changePage } = (0, offer_filter_context_1.useOffersFilterContextValue)();
    const [isSubscriptionModalOpen, setIsSubscriptionModalOpen] = react_1.default.useState(false);
    const [userIsSubscribed, setUserIsSubscribed] = react_1.default.useState(false);
    const mergedOffers = (0, mergePromotedOffersWithOffers_1.mergePromotedOffersWithOffers)({ promotedOffers, offers });
    const isOfferListEmpty = Boolean(mergedOffers && ((Array.isArray(mergedOffers) && !mergedOffers.length) || !mergedOffers));
    const isBelowMd = (0, react_styled_1.useBreakpoint)((0, styled_breakpoints_1.down)('md'));
    const fetchAndSetIsSubscribed = react_1.default.useCallback(async () => {
        try {
            const isUserLoggedIn = Boolean(account);
            if (isUserLoggedIn) {
                await Api.OfferNotificationSubscription.getSubscription();
                setUserIsSubscribed(true);
            }
            else {
                setUserIsSubscribed(false);
            }
        }
        catch (err) {
            setUserIsSubscribed(false);
        }
    }, [account]);
    react_1.default.useEffect(() => {
        fetchAndSetIsSubscribed();
    }, [fetchAndSetIsSubscribed, isSubscriptionModalOpen]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(elements_1.Head, { id: "offers" }), (0, jsx_runtime_1.jsxs)(elements_1.Holder, { marginVertical: true, children: [isBelowMd && (0, jsx_runtime_1.jsx)(OfferSearchFilterWrapper_1.OfferSearchFilterWrapper, {}), (0, jsx_runtime_1.jsxs)(exports.OffersMain, { children: [(0, jsx_runtime_1.jsxs)(exports.FilterColumn, { children: [(0, jsx_runtime_1.jsx)(Filters_1.Filters, { loading: areFiltersLoading }), isBelowMd && ((0, jsx_runtime_1.jsx)(FilterTags_1.FilterTags, { offerCounts: {
                                            offersCount: offers === null || offers === void 0 ? void 0 : offers.rowCount,
                                            allOffersCount: offers === null || offers === void 0 ? void 0 : offers.allOffersCount,
                                        } })), !userIsSubscribed && ((0, jsx_runtime_1.jsx)(OfferNotificationSubscriptionPanel_1.OfferNotificationSubscriptionPanel, { setIsModalOpen: setIsSubscriptionModalOpen }))] }), (0, jsx_runtime_1.jsxs)(exports.OffersColumn, { children: [!isBelowMd && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(OfferSearchFilterWrapper_1.OfferSearchFilterWrapper, {}), (0, jsx_runtime_1.jsx)(FilterTags_1.FilterTags, { offerCounts: {
                                                    offersCount: offers === null || offers === void 0 ? void 0 : offers.rowCount,
                                                    allOffersCount: offers === null || offers === void 0 ? void 0 : offers.allOffersCount,
                                                } })] })), !isOfferListEmpty && offers && ((0, jsx_runtime_1.jsx)(loading_wrapper_1.default, { isLoading: areOffersLoading && arePromotedOffersLoading, wrapperClassNames: "panel panel--offers", children: (0, jsx_runtime_1.jsx)("ul", { className: "offers__list", "data-cy": "offers-list", children: (0, jsx_runtime_1.jsx)(OffersList, { offers: mergedOffers }) }, "list") })), !areOffersLoading && isOfferListEmpty && ((0, jsx_runtime_1.jsx)(MissingContentView_1.default, { heading: intl.formatMessage({
                                            id: 'offers.missing_content_heading',
                                        }), message: intl.formatMessage({
                                            id: 'offers.missing_content_message',
                                        }) })), !areOffersLoading && !isOfferListEmpty && offers && ((0, jsx_runtime_1.jsx)(exports.StyledPagination, { current: offers.page, total: offers.rowCount, defaultPageSize: config_1.default.offers.itemsPerPage, onChange: changePage, showSizeChanger: false }))] })] }), (0, jsx_runtime_1.jsx)(OfferNotificationSubscriptionModal_1.OfferNotificationSubscriptionModal, { isOpen: isSubscriptionModalOpen, setIsOpen: setIsSubscriptionModalOpen })] })] }));
}
exports.OffersMain = styled_components_1.default.div `
	display: flex;

	${(0, styled_breakpoints_1.down)('md')} {
		flex-direction: column;
	}
`;
exports.FilterColumn = styled_components_1.default.div `
	min-width: 290px;
	max-width: 332px;
	flex: 1;
	margin-right: 1rem;

	${(0, styled_breakpoints_1.down)('md')} {
		width: 100%;
		max-width: 100%;
	}
`;
exports.OffersColumn = styled_components_1.default.div `
	flex: 1;
`;
